var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.74687 14.7511C5.60883 14.7515 5.49718 14.8636 5.49742 15.0017C5.49766 15.1397 5.6097 15.2515 5.74774 15.2513C5.88578 15.2512 5.99763 15.1393 5.99763 15.0012C5.99733 14.863 5.88513 14.7511 5.74686 14.7511",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9994 13.5006C10.8282 13.5006 11.5 14.1725 11.5 15.0012C11.5 15.83 10.8282 16.5019 9.9994 16.5019C9.17063 16.5019 8.49878 15.83 8.49878 15.0012C8.49878 14.1725 9.17063 13.5006 9.9994 13.5006",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0022 12V18.0025C17.0022 19.1075 16.1063 20.0033 15.0013 20.0033H4.99607C4.46556 20.0032 3.95684 19.7923 3.58182 19.4171C3.20679 19.0419 2.99619 18.533 2.99634 18.0025V11.9989C2.99648 11.4684 3.20736 10.9597 3.58259 10.5847C3.95782 10.2096 4.46666 9.99903 4.99717 9.99918H15.0024C15.5329 9.99932 16.0417 10.2102 16.4167 10.5854C16.7917 10.9607 17.0023 11.4695 17.0022 12Z",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2516 15.2513C14.3896 15.251 14.5013 15.1389 14.501 15.0008C14.5008 14.8628 14.3888 14.751 14.2507 14.7511C14.1127 14.7513 14.0008 14.8632 14.0008 15.0012C14.0011 15.1395 14.1133 15.2514 14.2516 15.2513",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19556 9.99917L7.40638 5.48029L7.40669 5.47929C7.54413 4.96688 7.87949 4.53006 8.339 4.26492C8.79851 3.99979 9.34453 3.92805 9.85693 4.0655L19.5202 6.65469L19.5212 6.655C20.0336 6.79244 20.4704 7.1278 20.7355 7.58732C21.0006 8.04683 21.0724 8.59285 20.9349 9.10525L19.3814 14.9032C19.1018 15.9418 18.0499 16.5724 17.0021 16.3296",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPay);
export default __webpack_public_path__ + "static/media/pay.d2a9533c28ea47488051c7e03cd17d36.svg";
export { ForwardRef as ReactComponent };